import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container } from "../../../components/atoms/Container";
import { Section } from "../../../components/atoms/Section";
import GuidesPosts from "../../../components/atoms/GuidesPosts";
import BreadCrumbBar from "../../../components/atoms/BreadCrumbBar";
import { GUIDES_TAB_BAR_SLUG, GUIDES_TAB_HEADER_COLOR, GUIDES_TITLE_NAME } from "../../../helpers/constants";

import glasses from "../../../assets/images/guides/glasses.png";
import GuidesHeader from "../../../components/molecules/GuidesHeader";
import urlPatterns from "../../../urls";
import { header } from "../../../styles/variables";
import GuidesTabNavigator from "../../../components/molecules/GuidesTabNavigator";

class GuidesTabGrape extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showBreadCrumbBar: true,
    };
  }

  async componentDidMount() {
    const { match, history, location } = this.props;
    const { params } = match || {};
    const { slug } = params || {};
    if (slug) {
      const { search } = location || {};
      history.push({
        pathname: urlPatterns.GUIDE_GRAPE_COLOR_GLOSSARY(slug),
        search,
      });
    }
  }

  render() {
    const { history, location } = this.props;

    const { showBreadCrumbBar } = this.state;

    return (
      <>
        <GuidesHeader
          headerIcon={glasses}
          headerColor={GUIDES_TAB_HEADER_COLOR.GUIDE_GRAPE_COLOR}
          headerTitle={GUIDES_TITLE_NAME.GUIDE_GRAPE_COLOR}
          headerDescription="Info on all the different grape varieties."
        />
        <GuidesTabNavigator
          mobileHeaderStyleTop={header.mobileHeight}
          shouldDisappearOnMobile
          backgroundColor={GUIDES_TAB_HEADER_COLOR.GUIDE_GRAPE_COLOR}
          urlGrapeType={urlPatterns.GUIDE_GRAPE_COLOR}
          location={location}
        />
        <Section xxs>
          {showBreadCrumbBar && (
            <BreadCrumbBar homeLabel="Guides" parentLabel="Grape Varieties" location={location} />
          )}
          <Container>
            <GuidesPosts
              history={history}
              filters={`${GUIDES_TAB_BAR_SLUG.GUIDE_GRAPE_COLOR}`}
              metaTitle="Wine Grape Varieties: Your Ultimate Guide | Good Pair Days"
              metaDescription="We closely look at 25+ different wine grape varieties alongside the defining
              factor of region vs grape type between the 'New World' and the 'Old World'."
              isFromTabGrape
              location={location}
            />
          </Container>
        </Section>
      </>
    );
  }
}

GuidesTabGrape.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default GuidesTabGrape;
